import angular from 'angular';

class principalLayoutCtrl {
    /* @ngInject */
    constructor($rootScope, $scope, $state, $translate, PrincipalSvc, AuthSvc) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$translate = $translate;
        this.PrincipalSvc = PrincipalSvc;
        this.AuthSvc = AuthSvc;
    }

    $onInit() {
        this.menuItems = this.PrincipalSvc.getMenuItems();
        this.principal = angular.copy(this.PrincipalSvc.getPrincipal());
        this.$rootScope.$watch(
            () => {
                return this.PrincipalSvc.getPrincipal();
            },
            () => {
                this.principal = angular.copy(this.PrincipalSvc.getPrincipal());
            }
        );
        this.$rootScope.$watch(
            () => {
                return this.$state.current;
            },
            () => this.setTitle()
        );
    }

    backList() {
        this.$state.go('do', { tabName: 'principal' });
    }

    canDisplayTab(role) {
        return this.AuthSvc.isAuthorized(role);
    }

    getPrincipal() {
        return this.PrincipalSvc.getPrincipal();
    }

    setTitle() {
        var titleByState = new Map();
        titleByState.set('app.principal.consult.listcompanies', 'principal.companies.title');
        titleByState.set('app.principal.consult.listsellers', 'principal.sellers.title');
        titleByState.set('app.principal.consult.listbuyers', 'principal.buyer.title');
        titleByState.set('app.principal.consult.create_company', 'principal.companies_details.createtitle');
        titleByState.set('app.principal.consult.detailsinvitation', 'principal.invitation_details.detailstitle');
        titleByState.set('app.principal.consult.detailsbuyerinvitation', 'principal.invitation_details.detailstitle');
        titleByState.set('app.principal.consult.updatecontainer', 'principal.container_details.update_title');
        titleByState.set('app.principal.consult.containers', 'principal.containers.title');
        titleByState.set('app.principal.consult.reports', 'principal.reports.title');
        titleByState.set('app.principal.consult.check_config', 'principal.check_configuration.title');
        titleByState.set('app.principal.consult.detailscontainer', 'principal.container.new_container');
        titleByState.set('app.principal.consult.group', 'principal.group.title');
        titleByState.set('app.principal.consult.group-creation', 'principal.group.creation.title');
        titleByState.set('app.principal.consult.group-edit', 'principal.group.edit.title');
        titleByState.set('app.principal.consult.users', 'principal.users.title');
        titleByState.set('app.principal.consult.create-user', 'principal.users.creation.title');
        titleByState.set('app.principal.consult.edit-user', 'principal.users.edit.title');
        titleByState.set('app.principal.consult.group-sub-entity-creation', 'principal.group.create_groupe');
        titleByState.set('app.principal.consult.personaliseportal', 'principal.personalise_portal.title');
        titleByState.set('app.principal.consult.details_divisions', 'principal.division.edit.title');
        titleByState.set('app.principal.consult.export_config', 'principal.export_configuration.title');
        titleByState.set('app.principal.consult.referential', 'principal.referential.title');
        titleByState.set('app.principal.consult.routing', 'principal.routing.creation.title');
        titleByState.set('app.principal.consult.offreApi', 'principal.offreApi.title');
        titleByState.set('app.principal.consult.details_subentity', 'principal.sub_entity.create.title');
        titleByState.set('app.principal.consult.acquittal', 'principal.acquittal.title');
        titleByState.set('app.principal.consult.billing_address', 'kiss_seller.edit.billing_address.title');
        titleByState.set('app.principal.consult.edit-billing_address', 'kiss_seller.edit.billing_address.edit.title');
        if (
            this.$state &&
            this.$state.current &&
            this.$state.current.name &&
            titleByState.has(this.$state.current.name)
        ) {
            this.title = titleByState.get(this.$state.current.name);
        } else if (
            this.$state &&
            this.$state.current &&
            this.$state.current.name === 'app.principal.consult.detailscompanies'
        ) {
            this.title = this.AuthSvc.isEditAuthorized()
                ? 'principal.companies_details.detailstitle'
                : 'principal.companies_details.consulttitle';
        } else if (
            this.$state &&
            this.$state.current &&
            this.$state.current.name === 'app.principal.consult.details_subentities'
        ) {
            this.title = this.AuthSvc.isEditAuthorized()
                ? 'principal.sub_entity.edit.title'
                : 'principal.sub_entity.consult.title';
        } else {
            if (this.create) {
                this.title = 'principal.create.title';
            } else if (this.AuthSvc.isEditAuthorized()) {
                this.title = 'principal.update.title';
            } else {
                this.title = 'principal.consult.title';
            }
        }
    }
}

angular.module('app.principal').component('principalLayout', {
    templateUrl: require('./principal-layout.html'),
    controller: principalLayoutCtrl,
    bindings: {
        create: '<',
    },
});
